import { ModuleManager, SectionList } from "@module-system";

import Buttons from "./Components/TestPageWhisperButtons.vue";
import AgentWhisperPopup from "./Components/AgentWhisperPopup.vue";
import AgentWhisperUrlShareButton from "./Components/AgentWhisperUrlShareButton.vue";
import AgentWhisperUrlShareModal from "./Components/AgentWhisperUrlShareModal.vue";

import CommonConditions from "@lib/commonConditions";
import { Actions, EventManager, Events } from "@events";
import locales from "./locales";
import { useLicenseState } from "@/stores/licenseState";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "Whisper",
  version: "1.0.0",
  register() {

    const licenseState = useLicenseState();

    if (!licenseState.hasLicensePackage("whisper")) {
      console.warn("Whisper module is not enabled in the license");
      return;
    }

    ModuleManager.addViewModule({
      section: "test_page_buttons_middle",
      ViewComponent: Buttons,
      key: "whisper_buttons",
      order: 0,
    });

    ModuleManager.addLocales(locales, "Whisper");

    ModuleManager.addRoute({
      path: "/w/:rtcId",
      name: "Whisper",
      props: true,
      component: () => import("./Components/SupervisorWhisperPage.vue"),
    });

    if (CommonConditions.isAgent()) {
      ModuleManager.addViewModule({
        section: SectionList.CallTopBar,
        name: "AgentWhisperPopup",
        props: true,
        ViewComponent: AgentWhisperPopup,
      });

      ModuleManager.addViewModule({
        key: "AgentWhisperUrlShareButton",
        section: SectionList.CallButtonsList,
        props: true,
        ViewComponent: AgentWhisperUrlShareButton,
      });

      ModuleManager.addViewModule({
        key: "AgentWhisperUrlShareModal",
        section: SectionList.CallModal,
        ViewComponent: AgentWhisperUrlShareModal,
      });
    }
  },
};
export default module;
